import { Component, Input } from "@angular/core";
import {
  MediaCategoryTypeNameEnum,
  MediaTypeNameEnum,
  ProductViewModelBase,
} from "src/domain/client";
import SettingNames from "src/domain/extentions/setting-names";

import { ShoppingCartService } from "src/services/shopping-cart.service";
import { ThemeService } from "src/services/theme.service";
import { URLService } from "src/services/url.service";

@Component({
  selector: "vw-product-card",
  templateUrl: "./product-card.component.html",
})
export class ProductCardComponent {
  @Input({ required: true }) product!: ProductViewModelBase;

  mediaCategoryTypeNames = MediaCategoryTypeNameEnum;
  mediaTypes = MediaTypeNameEnum;
  settingNames = SettingNames;

  constructor(
    public themeService: ThemeService,
    public shoppingCartService: ShoppingCartService,
    public urlService: URLService,
  ) {}

  createShoppingCartItem(product: ProductViewModelBase): void {
    if (product.productId == null || product.sku == null) {
      return;
    }
    this.shoppingCartService.addShoppingCartItem(
      product.productId,
      product.sku,
      product.minimumQuantity,
      product.media,
      1,
    );
  }

  //////////
}
